import type { ProductUpsellsConfig } from '#types/config/components/product/upsells'

export default {
  brandClasses: {
    carouselControls: 'top-5 mt-2 mx-2 !bg-transparent'
  }
} satisfies ProductUpsellsConfig
